import React from 'react';
import PropTypes from 'prop-types';

const Accordion = ({ title, detail, classes }) => {
  const wrapClasses = `accordion-input ${classes}`;

  return (
    <div className={wrapClasses}>
      <div className="accordion-input__title">{title}</div>
      <div className="accordion-input__detail">{detail}</div>
    </div>
  );
};

Accordion.propTypes = {
  title: PropTypes.object.isRequired,
  detail: PropTypes.object,
  classes: PropTypes.string,
};

export default Accordion;



// WEBPACK FOOTER //
// ./library/app/components/Global/Forms/Accordion.js